import React from 'react';
import PropTypes from 'prop-types';
import { METRIC_LABELS } from './Constants';

export default function Controls({ includeScenes, onToggle, metric, onMetricChange }) {
  return (
    <div className="bg-white bg-opacity-75 p-2 rounded-2 shadow-sm d-inline-block w-100">
      <div className="d-flex align-items-center">
        <div className="form-check me-3">
          <input 
            className="form-check-input" 
            type="checkbox" 
            id="toggleScenes" 
            checked={includeScenes} 
            onChange={onToggle} 
          />
          <label className="form-check-label fw-medium" htmlFor="toggleScenes">
            Include Scenes
          </label>
        </div>

        {/* Metric Selector pushed to the right */}
<select 
  className="form-select form-select-sm w-auto ms-auto metric-select-enhanced"
  value={metric} 
  onChange={e => onMetricChange(e.target.value)}
>
           {Object.entries(METRIC_LABELS).map(([val, label]) => (
            <option key={val} value={val}>{label}</option>
          ))}
        </select>
      </div>
    </div>
  );
}

Controls.propTypes = {
  includeScenes: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  metric: PropTypes.string.isRequired,
  onMetricChange: PropTypes.func.isRequired
};
